import React from 'react';
import { prepareData } from 'utils/googleData';

export const Agenda = (props) => {
    const {
        enable,
        title,
        items,
        direction
    } = prepareData({ props });

    if (enable?.toLowerCase?.() === 'false' && !process.env.RENDER_DISABLED_COMPONENTS) {
        return null;
    }

    return (
        <div direction={direction} className="p-5 bg-gray-50 rounded-lg shadow">
            <h3 className="text-xl font-bold text-gray-800 mb-4">{title}</h3>
           { items?.length > 0 && items?.map(({ to, from, description, emoji }, index) => (
                <div key={index} className="mb-3">
                    <h6 className="text-sm font-semibold text-gray-700">
                        {from} - {to} {emoji && <span>{emoji}</span>}
                    </h6>
                    <p className="text-gray-600" style={{ fontSize: 15 }}>
                        {description}
                    </p>
                </div>
            ))}
        </div>
    );
};

export default Agenda;
